import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, Flame } from "lucide-react";

export default function FoodCard({ food, onClick }) {
  return (
    <Card
      onClick={onClick}
      className="p-5 rounded-2xl border-border shadow-none hover:-translate-y-1 hover:border-foreground/30 transition-all cursor-pointer"
      data-testid={`food-card-${food.id}`}
    >
      <div className="flex items-start justify-between gap-2 mb-3">
        <div className="flex-1">
          <div className="overline mb-1">{food.cuisine}</div>
          <h3 className="font-serif text-lg font-semibold tracking-tight leading-tight">{food.name}</h3>
        </div>
        <div className="text-right">
          <div className="text-xs text-muted-foreground">Comfort</div>
          <div className="font-serif text-xl font-semibold tabular-nums">{food.comfort_score}</div>
        </div>
      </div>
      <div className="text-xs text-muted-foreground mb-3">{food.region}, {food.country}</div>
      <div className="flex flex-wrap items-center gap-1.5">
        <Badge variant="outline" className="rounded-full text-[10px] capitalize">{food.diet_type}</Badge>
        <Badge variant="secondary" className="rounded-full text-[10px]"><Flame className="w-2.5 h-2.5 mr-0.5" strokeWidth={1.75} /> {food.spice_level}/5</Badge>
        <Badge variant="secondary" className="rounded-full text-[10px]"><Clock className="w-2.5 h-2.5 mr-0.5" strokeWidth={1.75} /> {food.prep_time}m</Badge>
      </div>
    </Card>
  );
}
